<template>
  <div class="app-scaler">
    <div class="viewport-wrapper">
      <div class="design-viewport">
        <router-view />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
// 设计稿基准尺寸（移动端 H5 常见 375x812）
$design-width: 375px;
$design-height: 812px;

// 实际设计稿宽度比例（用于适配不同屏幕）
$scale-ratio: calc(100vw / #{$design-width});

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  height: 100vh;
  height: 100dvh; /* 动态视口，兼容手机模拟器及真机 */
  min-height: -webkit-fill-available;
  overflow: hidden;
  overscroll-behavior: none;
  -webkit-tap-highlight-color: transparent;
}

#app {
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* 禁止图片被长按拖动 */
#app img {
  -webkit-user-drag: none;
  user-drag: none;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: auto;
}

/* 整体缩放容器 */
.app-scaler {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  min-height: -webkit-fill-available;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-x: hidden;
  overflow-y: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

/* 包裹层：移动端直接撑开 */
.viewport-wrapper {
  width: 100vw;
  flex-shrink: 0;
}

/* 设计稿容器：移动端铺满宽度，内部可纵向滚动 */
.design-viewport {
  width: 100vw;
  height: auto;
  min-height: 100vh;
  min-height: 100dvh;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

/* PC 端：按比例铺满视口，居中展示，两侧显示白边 */
@media (min-width: 768px) {
  .app-scaler {
    justify-content: center;
    align-items: center;
    background: #fff;
  }

  .viewport-wrapper {
    width: $design-width;
    height: $design-height;
  }

  .design-viewport {
    width: $design-width;
    height: auto;
  }
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
